import { useMutation } from '@apollo/client';

import { UPDATE_USER_SETTINGS } from 'graphql/users/mutations/updateUserSettings.gql';

export default function useUpdateUserSettingsMutation() {
  return useMutation(UPDATE_USER_SETTINGS);
}
